<template>
  <div>
    <div class="row">
      <div class="col-md-12 form-group">
        <textarea class="form-control" rows="22" readonly>
					{{ agreement.length > 0 ? agreement[0].company_agreement.content_kh : '' }}
					{{ agreement.length > 0 ? agreement[0].company_agreement.content_en : '' }}
				</textarea
        >
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <ts-checkbox v-model="model.is_agreed">
          {{
            $t('school.academic.operation.profile_mgt.parentProfile.readTerm')
          }}
        </ts-checkbox>
      </div>
      <div class="col-md-4 form-group">
        <div class="d-flex justify-content-end">
          <span class="mr-2 mt-2">{{ model.agreement_display_name }}</span>
          <label class="btn btn-default" for="attachFile"
            >`
            {{
              $t(
                'school.academic.operation.profile_mgt.parentProfile.attachFile'
              )
            }}
          </label>
          <input
            type="file"
            @change="fileChange"
            id="attachFile"
            ref="attachFile"
            style="display: none"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'parentAgreement',
  props: ['value', 'clear'],
  data() {
    return {
      model: {},
      fetch_agreement: true
    }
  },
  created() {
    this.model = this.value
    this.setEditData()
  },
  computed: {
    ...mapState('parentProfile', ['agreement', 'edit_data'])
  },
  methods: {
    ...mapActions('parentProfile', ['getAgreement']),
    fileChange(event) {
      let file = event.target.files[0]

      if (file === undefined) return

      this.model.file = file
      this.model.agreement_display_name = file.name
    },
    async setEditData() {
      await this.getAgreement().finally(() => {
        this.fetch_agreement = false
      })
      if (!_.isEmpty(this.edit_data)) {
        ;(this.model.agreement_cat_id = this.edit_data.agreement.agreement_cat_id),
          (this.model.agreement_attached_file = this.edit_data.agreement.agreement_attached_file),
          (this.model.agreement_display_name = this.edit_data.agreement.agreement_display_name),
          (this.model.is_agreed = this.edit_data.agreement.is_agreed)
      } else {
        this.model.agreement_cat_id =
          this.agreement.length > 0 ? this.agreement[0].agreement_cat_id : null
      }
    }
  },
  watch: {
    clear: function(value) {
      if (value) {
        this.model = this.value
        this.$refs.attachFile.value = ''
      }
    }
  }
}
</script>
